module.exports = "\n<div class=\"loader\" :class=\"inline ? 'inline' : ''\" _v-c85da906=\"\">\n    <i class=\"glyphicon glyphicon-refresh\" _v-c85da906=\"\"></i>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-c85da906!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 539
// module chunks = 0